import { render, staticRenderFns } from "./shengtaihuanjing.vue?vue&type=template&id=085b9888&scoped=true&"
import script from "./shengtaihuanjing.vue?vue&type=script&lang=js&"
export * from "./shengtaihuanjing.vue?vue&type=script&lang=js&"
import style0 from "./shengtaihuanjing.vue?vue&type=style&index=0&id=085b9888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085b9888",
  null
  
)

export default component.exports